import { differenceInYears } from 'date-fns';
import { arrayBuilderPages } from 'platform/forms-system/src/js/patterns/array-builder';
import { whenAll, whenNot } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';
import { includeHouseholdInformation } from '../../../../utils/helpers';
import addtlInformation from './addtlInformation';
import annualIncome from './annualIncome';
import basicInformation from './basicInformation';
import educationExpenses from './educationExpenses';
import financialSupport from './financialSupport';
import summary, { dependentOptions } from './summary';

const cohabited = (formData, index) =>
  formData.dependents[index]?.cohabitedLastYear;

const hasIncomeToDeclare = (formData, index) =>
  formData.dependents[index]?.['view:dependentIncome'];

const hasGrossIncome = (formData, index) => {
  const { grossIncome = 0 } =
    formData.dependents[index]?.['view:grossIncome'] || {};
  return parseFloat(grossIncome) > 0;
};

const isOfCollegeAge = (formData, index) => {
  const birthdate = formData.dependents[index]?.dateOfBirth;
  if (!birthdate) return false;

  const age = differenceInYears(new Date(), new Date(birthdate));
  return age >= 18 && age <= 23;
};

export const dependentsPages = arrayBuilderPages(
  dependentOptions,
  pagebuilder => ({
    dependentsSummary: pagebuilder.summaryPage({
      title: content['dependent-info--summary-title'],
      path: 'household-information/dependents',
      depends: includeHouseholdInformation,
      ...summary,
    }),
    dependentBasicInfo: pagebuilder.itemPage({
      title: content['dependent-info--basic-title'],
      path: 'household-information/dependents/:index/basic-information',
      depends: includeHouseholdInformation,
      ...basicInformation,
    }),
    dependentAddtlInfo: pagebuilder.itemPage({
      title: content['dependent-info--addtl-title'],
      path: 'household-information/dependents/:index/additional-information',
      depends: includeHouseholdInformation,
      ...addtlInformation,
    }),
    dependentFinancialSupport: pagebuilder.itemPage({
      title: content['dependent-info--support-title'],
      path: 'household-information/dependents/:index/financial-support',
      depends: whenAll(includeHouseholdInformation, whenNot(cohabited)),
      ...financialSupport,
    }),
    dependentAnnualIncome: pagebuilder.itemPage({
      title: content['dependent-info--income-title'],
      path: 'household-information/dependents/:index/annual-income',
      depends: whenAll(includeHouseholdInformation, hasIncomeToDeclare),
      ...annualIncome,
    }),
    dependentEducationExpenses: pagebuilder.itemPage({
      title: content['dependent-info--education-title'],
      path: 'household-information/dependents/:index/education-expenses',
      depends: whenAll(
        includeHouseholdInformation,
        isOfCollegeAge,
        hasGrossIncome,
      ),
      ...educationExpenses,
    }),
  }),
);
